import React, { useEffect, createElement } from 'react';
import { SalesPage } from './components/SalesPage';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }
    // Load Meta Pixel script
    !function (f: any, b: any, e: string, v: string, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Check if s exists before using parentNode
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        // Fallback: append to head if no script tags exist
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', '1423074459182335');
    (window as any).fbq('track', 'PageView');
    console.log('✅ Meta Pixel loaded - ID: 1423074459182335');
    console.log('✅ PageView tracked');
  }, []);
  return <div className="w-full min-h-screen bg-cream-50" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1423074459182335&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <SalesPage data-id="element-3" />
    </div>;
}